import { Component, Input, ViewChild } from '@angular/core';

import { IMenuItem } from '../menuInterfaces/menu-item.interface';
import { TopnavInfoService } from '../menuInterfaces/topnav-info.service';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-nav-bar-menu-item',
  templateUrl: './nav-bar-menu-item.component.html',
  styleUrls: ['./nav-bar-menu-item.component.scss']
})
export class NavBarMenuItemComponent {
  @Input() items: IMenuItem[];
  @Input() basePath: string[];

  @ViewChild('childMenu', { static: true }) public childMenu;

  userRole$ = this.infoService.getUserRoles();

  constructor(private infoService: TopnavInfoService) {}

  fullPath = (path: string): string[] => {
    if (this.basePath !== undefined) {
      return [...this.basePath, path];
    } else {
      return [path];
    }
  };

  rolesOk = (roles: string[]) => {
    if (!roles) {
      return of(true);
    }

    return this.userRole$.pipe(map(userRoles => roles.some(role => userRoles.indexOf(role) >= 0)));
  };
}
